import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from './shadcn/dialog';
import PanelHeading from '../brand/PanelHeading';
import type { BearriMotionName } from '../brand/motionAssets';
import type { DoodleName } from '../brand/Doodle';
import './paperDialog.css';

export default function PaperDialog({title, description, eyebrow, motion, doodle, onClose, children, wide = false}: {
  title:string; description?:string; eyebrow?:string; motion?:BearriMotionName;
  /** a drawing of the object the dialog is about — for dialogs that carry no bear */
  doodle?:DoodleName;
  onClose:() => void; children:React.ReactNode;
  /** a wider sheet for a ledger or a chart (the performance report) */
  wide?:boolean;
}) {
  const returnFocus = React.useRef<HTMLElement | null>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);
  return <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
    {/* The dialog portals to <body>, outside .br-workspace — .br-desk carries the
        desk's tokens and objects with it so fields and slabs inside still render as paper. */}
    <DialogContent ref={contentRef} className={`br-paper-dialog br-desk${wide ? ' br-paper-dialog--wide' : ''}`} {...(!description ? {'aria-describedby':undefined} : {})}
      onOpenAutoFocus={event => {
        // These dialogs use external triggers. Remember the initiating control
        // before Radix moves focus to the first form control or close button.
        returnFocus.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        // A playful header button must not steal initial focus from the form.
        const firstControl = contentRef.current?.querySelector<HTMLElement>(
          '.br-paper-dialog__body input:not([disabled]):not([type=hidden]), .br-paper-dialog__body textarea:not([disabled]), .br-paper-dialog__body select:not([disabled]), .br-paper-dialog__body button:not([disabled]), .br-paper-dialog__body a[href]',
        );
        if (firstControl) {event.preventDefault();firstControl.focus();}
      }}
      onCloseAutoFocus={event => {
        event.preventDefault();
        if (returnFocus.current?.isConnected) returnFocus.current.focus();
      }}>
      <PanelHeading className="br-paper-dialog__heading" motion={motion} doodle={doodle} eyebrow={eyebrow}
        title={<DialogTitle>{title}</DialogTitle>}
        description={description ? <DialogDescription>{description}</DialogDescription> : undefined} />
      <div className="br-paper-dialog__body">{children}</div>
    </DialogContent>
  </Dialog>;
}
